import DependentsRows from "./DependentsRows"
import { Form, Table } from 'react-bootstrap';

function DependentsTable({ applicants, primaryFirstName, primaryLastName, primaryMiddleName, counties }) {

    const mssn = (event) => {
       
        var v = event.target.value;
        //console.log(event);
        var r = v.replace(/\D/g, "");

        if (r.length > 9) {
            r = r.replace(/^(\d\d\d)(\d{2})(\d{0,4}).*/, "$1-$2-$3");
            return r;
        }
        else if (r.length > 4) {
            r = r.replace(/^(\d\d\d)(\d{2})(\d{0,4}).*/, "$1-$2-$3");
        }
        else if (r.length > 2) {
            r = r.replace(/^(\d\d\d)(\d{0,3})/, "$1-$2");
        }
        else {
            r = r.replace(/^(\d*)/, "$1");
        }
        document.getElementById(event.target.id).value = r;
        return r;
    }

    const primaryApplicant = () => {
        return applicants?.find(x => x.type === 'Primary');
    }

    const otherApplicants = () => {
        return applicants?.filter(x => x.type !== 'Primary');
    }

    return (
        <div className="container">
            <div className="row">
                <div >
                    <Table>
                        <thead>
                            <tr>                                
                                <th style={{ width: "20%" }}>Relationship *</th>
                                <th style={{ width: "9%" }}>Sex *</th>
                                <th colSpan={3} style={{ width: "27%" }}>Name (Last (suffix), First, MI) *</th>
                                <th style={{ width: "14%" }}>US citizen? *</th>
                                <th style={{ width: "13%" }}>Social Security Number *</th>
                                <th style={{ width: "5%" }}>Date of Birth (MM/DD/YYYY) *</th>
                                <th style={{ width: "12%" }}>Tobacco use in the past 6 months? *</th>
                                <th style={{ width: "3%" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key="primaryApplicant">                                
                                <td>
                                    <Form.Group controlId={`applicant_Relationship_0`}>
                                        <Form.Control type="text" className='mb-2' value="Primary" disabled={true} required />
                                    </Form.Group>
                                </td>
                                <td className="d-flex centered">
                                    <Form.Group controlId={`applicant_Sex_0`} >
                                        <Form.Select className='mb-2' defaultValue={primaryApplicant()?.sex} readOnly required disabled>
                                            <option hidden value="">Sex</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </Form.Select>
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group controlId={`applicant_Lastname_0`} name="lastname">
                                        <Form.Control type="text" defaultValue={primaryLastName} className='mb-2' placeholder={`Last (Suffix)`} required />
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group controlId={`applicant_Firstname_0`} name="firstname">
                                        <Form.Control type="text" defaultValue={primaryFirstName} className='mb-2' placeholder={`First`} required />
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group controlId={`applicant_Middlename_0`} name="middlename">
                                        <Form.Control type="text" defaultValue={primaryMiddleName} className='mb-2' placeholder={`Middle`} />
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group controlId={`applicant_Citizenship_0`}>
                                        <Form.Select className='mb-2' required>
                                            <option hidden value="">Citizenship</option>
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group controlId={`applicant_SSN_0`}>
                                        <Form.Control type="text" className='mb-2' maxLength={11} minLength={11} pattern="^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$" placeholder="000-00-0000" onKeyUp={mssn} onBlur={mssn} required />
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group controlId={`applicant_DOB_0`}>
                                        <Form.Control type="date" className='mb-2' value={primaryApplicant()?.dateOfBirth} readOnly required disabled />
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group controlId={`applicant_Tobacco_0`}>
                                        <Form.Select className='mb-2' value={primaryApplicant()?.tobacco} readOnly required disabled>
                                            <option hidden value="">Usage</option>
                                            <option value={false}>No</option>
                                            <option value={true}>Yes</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <input type="hidden" id="applicant_Rate_0" value={primaryApplicant()?.rate} />
                                </td>
                            </tr>
                            <DependentsRows applicants={otherApplicants()} mssn={mssn} counties={counties} />
                        </tbody>
                    </Table>
                </div>
                <div className="col-sm-4">
                </div>
            </div>
        </div>
    )
}

export default DependentsTable
